import classNames from 'classnames'
import { DeepPartial } from '@/root/types/utilities'
import Link from '@/components/Common/Link'

export interface BreadCrumbProps {
  breadCrumbList?: Array<{ label: string; link?: string; txtStyle?: string }>
  extraClassNames?: string
  labelClassName?: string
  structuredSchemaInHTML?: boolean
}

const BreadCrumb = (props: DeepPartial<BreadCrumbProps>) => {
  const {
    breadCrumbList,
    extraClassNames,
    labelClassName,
    structuredSchemaInHTML,
  } = props

  const conditionalProps = {
    list: {},
    listItem: {},
    link: {},
    labelText: {},
    meta: {},
  }

  if (structuredSchemaInHTML) {
    conditionalProps.list = {
      itemScope: true,
      itemType: 'https://schema.org/BreadcrumbList',
    }

    conditionalProps.listItem = {
      itemScope: true,
      itemType: 'https://schema.org/ListItem',
      itemProp: 'itemListElement',
    }

    conditionalProps.link = {
      itemProp: 'item',
    }

    conditionalProps.labelText = {
      itemProp: 'name',
    }

    conditionalProps.meta = {
      itemProp: 'position',
    }
  }

  return (
    <ul
      className={classNames(
        'md:text-13px no-scrollbar text-brand-grey-base mr-2 flex overflow-scroll text-[11px] leading-4 md:leading-5',
        extraClassNames,
      )}
      {...conditionalProps.list}
    >
      {breadCrumbList?.map((item, idx) => {
        if (!item) return null

        const { label = '', link = '', txtStyle = '' } = item

        const jsx = (
          <>
            <span
              className={classNames('mr-2', txtStyle)}
              {...conditionalProps.labelText}
            >
              {label}
            </span>
            {structuredSchemaInHTML && (
              <meta {...conditionalProps.meta} content={(idx + 1).toString()} />
            )}
          </>
        )

        return (
          <li
            key={`${idx}${label}`}
            className={classNames('flex flex-shrink-0', {
              [`font-medium ${labelClassName}`]: !link,
            })}
            {...conditionalProps.listItem}
          >
            {link ? (
              <>
                <Link
                  href={link}
                  className="cursor-pointer"
                  title={label}
                  {...conditionalProps.link}
                >
                  {jsx}
                </Link>
                {idx < breadCrumbList.length - 1 && (
                  <span className="mr-2">&gt;</span>
                )}
              </>
            ) : (
              jsx
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default BreadCrumb
